import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import "antd/dist/antd.css";
import App from "./App";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./store/index";

import { setLoggedInUserOnReload } from "./actions/auth.action";
import NetworkModal from "./components/modals/NetworkModal";

const store = configureStore();
setLoggedInUserOnReload(store).catch((error) => console.log(error));

const Main = () => {
  const [networkStatus, updateNetworkStatus] = useState(navigator.onLine);
  const updateNetwork = () => updateNetworkStatus(navigator.onLine);

  useEffect(() => {
    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
    };
  }, []);
  const networkRender = !networkStatus ? <NetworkModal /> : null;

  return (
    <Provider store={store}>
      <App />
      {networkRender}
    </Provider>
  );
};
ReactDOM.render(<Main />, document.getElementById("root"));
// serviceWorkerRegistration.register();
reportWebVitals();
